// Parses a free-text "Additional recipients (CC)" field (comma-, semicolon-,
// or newline-separated) into a validated, deduped, lowercase array of
// emails. Shared by the workspace-wide setting (SettingsPage) and its
// per-template / per-packet overrides, so all three validate identically.
export function parseCcEmails(raw) {
  const emails = String(raw || '')
    .split(/[,;\n]/)
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);
  const invalid = emails.filter((e) => !/^\S+@\S+\.\S+$/.test(e));
  if (invalid.length > 0) {
    throw new Error(`Invalid email(s): ${invalid.join(', ')}`);
  }
  return [...new Set(emails)];
}
